// removed by extract-text-webpack-plugin
module.exports = {"featured":"P2u8","featured-content":"pUyl","dropdownOpen":"y6Uj","theme-light":"_1ymv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturedHead/FeaturedHead.styl
// module id = 79
// module chunks = 0